"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UploadZone = exports.UploadButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _connect = require("../connect");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Button = _interopRequireDefault(require("../Button"));
var _Input = require("./Input");
var _utils = require("../utils");
var _Wait = _interopRequireDefault(require("../Wait"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// ----- COMPONENT
var Upload = /*#__PURE__*/function (_Component) {
  _inherits(Upload, _Component);
  var _super = _createSuper(Upload);
  function Upload(props) {
    var _this;
    _classCallCheck(this, Upload);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "refOpen", function () {
      _this.dropzoneRef.current.open();
    });
    _defineProperty(_assertThisInitialized(_this), "onUpdate", function (items) {
      if (_this.props.onChange) {
        if (items && items.length > 0) {
          if (_this.multiple || Array.isArray(_this.props.value)) {
            var outputs = _this.props.value || [];
            items.forEach(function (item) {
              if (_this.props.tag) item.tag = _this.props.tag;
              outputs.push(item);
            });
            _this.props.onChange(_toConsumableArray(outputs));
          } else {
            if (_this.props.tag) items[0].tag = _this.props.tag;
            _this.props.onChange(items[0]);
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onRemove", function (item) {
      if (_this.props.readOnly) return;
      if (_this.props.onChange) {
        var pare = JSON.stringify(item);
        _this.props.onChange(_this.props.value.filter(function (item) {
          return JSON.stringify(item) !== pare;
        }));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onRemoveAll", function () {
      if (_this.props.onChange) {
        _this.props.onChange(null);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onUpload", function (files) {
      _this.setState({
        wait: true,
        enter: false
      });
      var data = new FormData();
      files.forEach(function (file) {
        return data.append('files[]', file);
      });
      (0, _connect.post)(_this.props.url || 'upload', data).then(function (d) {
        _this.setState({
          wait: false,
          error: !!d.errors && d.errors
        }, function () {
          _this.onUpdate(d.files);
          if (_this.props.onError && d.errors && d.errors.length) _this.props.onError(d.errors);
        });
      });
    });
    _this.state = {
      wait: false,
      enter: false,
      error: null
    };
    _this.dropzoneRef = /*#__PURE__*/(0, React.createRef)();
    _this.multiple = !!props.multiple;
    return _this;
  }
  _createClass(Upload, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var items = [];
      var _this$props = this.props,
        tag = _this$props.tag,
        value = _this$props.value,
        accept = _this$props.accept,
        label = _this$props.label,
        labelButton = _this$props.labelButton,
        classBox = _this$props.classBox;
      var _this$state = this.state,
        wait = _this$state.wait,
        enter = _this$state.enter,
        error = _this$state.error;
      if (Array.isArray(value)) {
        value.filter(function (v) {
          return !tag || tag === v.tag;
        }).forEach(function (f, x) {
          items.push( /*#__PURE__*/React.createElement("div", {
            key: 'upload_' + x,
            className: 'un-input-upload-item'
          }, /*#__PURE__*/React.createElement(_Icon.default, {
            name: 'file',
            className: "_icon"
          }), f.url ? /*#__PURE__*/React.createElement("a", {
            href: f.url,
            className: '_name',
            target: '_blank',
            rel: "noopener noreferrer"
          }, f.name) : /*#__PURE__*/React.createElement("span", {
            className: '_name'
          }, f.name), !_this2.props.readOnly && /*#__PURE__*/React.createElement(_Icon.default, {
            className: "_btn-clear",
            name: 'times',
            onClick: function onClick() {
              return _this2.onRemove(f);
            }
          })));
        });
      } else if (!(0, _utils.isEmpty)(value)) {
        items.push( /*#__PURE__*/React.createElement("div", {
          key: 'upload_file',
          className: 'un-input-upload-item'
        }, /*#__PURE__*/React.createElement(_Icon.default, {
          name: 'file',
          className: "_icon"
        }), value.url ? /*#__PURE__*/React.createElement("a", {
          href: value.url,
          className: '_name',
          target: '_blank',
          rel: "noopener noreferrer"
        }, value.name) : /*#__PURE__*/React.createElement("span", {
          className: '_name'
        }, value.name), !this.props.readOnly && /*#__PURE__*/React.createElement(_Icon.default, {
          className: "_btn-clear",
          name: 'times',
          onClick: this.onRemoveAll
        })));
      }
      if (error) items.push( /*#__PURE__*/React.createElement("div", {
        key: 'upload_error',
        className: 'un-input-upload-item -error'
      }, /*#__PURE__*/React.createElement(_Icon.default, {
        name: 'exclamation-triangle mx-1 red'
      }), " ", (error === null || error === void 0 ? void 0 : error.error) || 'Error'));
      if (wait) items.push( /*#__PURE__*/React.createElement("div", {
        key: 'upload_wait',
        className: 'un-input-upload-item -wait'
      }, /*#__PURE__*/React.createElement(_Icon.default, {
        name: 'spinner mx-1',
        spin: true
      }), " Uploading ..."));
      var dzProps = {
        ref: this.dropzoneRef,
        onDrop: this.onUpload,
        onDragEnter: function onDragEnter() {
          return _this2.setState({
            enter: true
          });
        },
        onDragLeave: function onDragLeave() {
          return _this2.setState({
            enter: false
          });
        },
        noClick: true,
        noKeyboard: true
      };
      if (accept) dzProps.accept = accept;
      var clsName = (0, _utils.clsNames)((0, _Input.createInputboxClass)('un-input-upload', this.props), ((!!items && items.length) > 0 || wait) && '-focus', enter && '-enter');
      var input = this.props.readOnly ? /*#__PURE__*/React.createElement("div", {
        className: clsName
      }, /*#__PURE__*/React.createElement("div", {
        className: 'un-input-upload-items'
      }, items), !this.props.form && !!label && (0, _Input.createInputboxLabel)(label)) : /*#__PURE__*/React.createElement(_reactDropzone.default, dzProps, function (_ref) {
        var rp = _ref.getRootProps,
          ip = _ref.getInputProps;
        return /*#__PURE__*/React.createElement("div", _extends({
          className: clsName
        }, rp()), /*#__PURE__*/React.createElement("input", _extends({
          title: "input-file"
        }, ip())), /*#__PURE__*/React.createElement("div", {
          className: 'un-input-upload-items'
        }, items), !_this2.props.form && !!label && (0, _Input.createInputboxLabel)(label), /*#__PURE__*/React.createElement("div", {
          className: "un-inputbox-pend -show"
        }, /*#__PURE__*/React.createElement(_Button.default, {
          info: true,
          sm: true,
          onClick: _this2.refOpen
        }, labelButton || 'Upload')));
      });
      if (this.props.form) return (0, _Input.createFormitem)(input, this.props);
      if (typeof classBox === 'string') return /*#__PURE__*/React.createElement("div", {
        className: classBox
      }, input);
      return input;
    }
  }]);
  return Upload;
}(React.Component);
exports.default = Upload;
var UploadButton = /*#__PURE__*/function (_Component2) {
  _inherits(UploadButton, _Component2);
  var _super2 = _createSuper(UploadButton);
  function UploadButton(props) {
    var _this3;
    _classCallCheck(this, UploadButton);
    _this3 = _super2.call(this, props);
    _defineProperty(_assertThisInitialized(_this3), "refOpen", function () {
      _this3.dropzoneRef.current.open();
    });
    _defineProperty(_assertThisInitialized(_this3), "onUpload", function (files) {
      _this3.setState({
        wait: true,
        enter: false
      });
      var data = new FormData();
      files.forEach(function (file) {
        return data.append('files[]', file);
      });
      (0, _connect.post)(_this3.props.url || 'upload', data).then(function (d) {
        _this3.setState({
          wait: false
        });
        if (_this3.props.onUploaded) _this3.props.onUploaded(d);
      });
    });
    _this3.dropzoneRef = /*#__PURE__*/(0, React.createRef)();
    _this3.state = {
      wait: false,
      enter: false,
      error: null
    };
    _this3.dzProps = {
      ref: _this3.dropzoneRef,
      onDragEnter: function onDragEnter() {
        return _this3.setState({
          enter: true
        });
      },
      onDragLeave: function onDragLeave() {
        return _this3.setState({
          enter: false
        });
      },
      onDrop: _this3.onUpload,
      noClick: true,
      noKeyboard: true
    };
    if (props.accept) _this3.dzProps.accept = props.accept;
    return _this3;
  }
  _createClass(UploadButton, [{
    key: "renderChildren",
    value: function renderChildren() {
      if (this.props.children) return this.props.children;
      if (this.props.icon) return null;
      return 'Upload';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var buttonProp = {};
      if (this.props.iconButton && this.props.icon && typeof this.props.icon === 'string') {
        buttonProp.button = true;
        buttonProp.name = this.state.wait || this.props.loading ? 'spinner fa-spin' : this.props.icon;
      } else {
        var props = ['fullWidth', 'outline', 'flat', 'icon', 'xs', 'sm', 'lg', 'm0', 'primary', 'secondary', 'success', 'info', 'warning', 'error', 'dark'];
        props.forEach(function (p) {
          // @ts-ignore
          if (_this4.props[p] !== undefined) buttonProp[p] = _this4.props[p];
        });
        buttonProp.loading = this.state.wait || this.props.loading;
      }
      return /*#__PURE__*/React.createElement(_reactDropzone.default, this.dzProps, function (ch) {
        return /*#__PURE__*/React.createElement("div", _extends({
          className: (0, _utils.clsNames)('un-input-upload-button', _this4.props.className)
        }, ch.getRootProps()), /*#__PURE__*/React.createElement("input", _extends({
          title: "input-file"
        }, ch.getInputProps())), _this4.props.iconButton && _this4.props.icon && typeof _this4.props.icon === 'string' ? /*#__PURE__*/React.createElement(_Icon.default, _extends({}, buttonProp, {
          onClick: _this4.refOpen
        })) : /*#__PURE__*/React.createElement(_Button.default, _extends({}, buttonProp, {
          onClick: _this4.refOpen
        }), _this4.renderChildren()));
      });
    }
  }]);
  return UploadButton;
}(React.Component);
exports.UploadButton = UploadButton;
var UploadZone = /*#__PURE__*/function (_Component3) {
  _inherits(UploadZone, _Component3);
  var _super3 = _createSuper(UploadZone);
  function UploadZone(props) {
    var _this5;
    _classCallCheck(this, UploadZone);
    _this5 = _super3.call(this, props);
    _defineProperty(_assertThisInitialized(_this5), "onUpload", function (files) {
      _this5.setState({
        wait: true,
        enter: false
      });
      var data = new FormData();
      files.forEach(function (file) {
        return data.append('files[]', file);
      });
      (0, _connect.post)(_this5.props.url || 'upload', data).then(function (d) {
        _this5.setState({
          wait: false
        });
        if (_this5.props.onUploaded) _this5.props.onUploaded(d);
      });
    });
    _this5.state = {
      wait: false,
      enter: false,
      error: null
    };
    _this5.dzProps = {
      onDrop: _this5.onUpload,
      onDragEnter: function onDragEnter() {
        return _this5.setState({
          enter: true
        });
      },
      onDragLeave: function onDragLeave() {
        return _this5.setState({
          enter: false
        });
      },
      noClick: true,
      noKeyboard: true
    };
    if (props.accept) _this5.dzProps.accept = props.accept;
    return _this5;
  }
  _createClass(UploadZone, [{
    key: "render",
    value: function render() {
      var _this6 = this;
      return /*#__PURE__*/React.createElement(_reactDropzone.default, this.dzProps, function (ch) {
        return /*#__PURE__*/React.createElement("div", _extends({
          className: (0, _utils.clsNames)('un-input-upload-zone', _this6.props.className, _this6.state.wait && '-loading', _this6.state.enter && '-enter')
        }, ch.getRootProps()), /*#__PURE__*/React.createElement("input", _extends({
          title: "input-file"
        }, ch.getInputProps())), _this6.state.enter && /*#__PURE__*/React.createElement("div", {
          className: "_zone-drop"
        }, "Drop Files"), _this6.state.wait && /*#__PURE__*/React.createElement(_Wait.default, {
          icon: "spinner",
          color: "grey-blue"
        }), _this6.props.children);
      });
    }
  }]);
  return UploadZone;
}(React.Component);
exports.UploadZone = UploadZone;